import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getBackdateConfig, updateBackdateConfig } from "../../pages/api/backdateConfig";

const BackdateConfigSetting = ({ show, onHide }) => {
  const token = localStorage.getItem("token");
  const [current, setCurrent] = useState(null);
  const [value, setValue] = useState("");
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!show) return;
    setEditing(false);
    setError("");
    setSuccess("");
    getBackdateConfig(token)
      .then((r) => {
        setCurrent(r.data.maxBackdateDays);
        setValue(String(r.data.maxBackdateDays ?? ""));
      })
      .catch(() => setError("Failed to load configuration"));
  }, [show, token]);

  const cancelEdit = () => {
    setValue(String(current ?? ""));
    setEditing(false);
    setError("");
  };

  const save = async () => {
    const n = Number(value);
    if (value === "" || !Number.isInteger(n) || n < 1 || n > 365) {
      setError("Enter a whole number between 1 and 365");
      return;
    }
    try {
      setSaving(true);
      const r = await updateBackdateConfig(n, token);
      setCurrent(r.data.maxBackdateDays);
      setValue(String(r.data.maxBackdateDays));
      setEditing(false);
      setError("");
      setSuccess("Backdate configuration updated");
    } catch (e) {
      setError(e?.response?.data?.message || "Failed to update");
      setSuccess("");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="cpw-modal">
      <div className="cpw-header">
        <div className="cpw-header-left">
          <div className="cpw-icon"><i className="bi bi-calendar-check"></i></div>
          <div>
            <div className="cpw-title">Backdate Configuration</div>
            <div className="cpw-subtitle">Limit backdated daily reporting</div>
          </div>
        </div>
        <button className="cpw-close-btn" onClick={onHide}><i className="bi bi-x-lg"></i></button>
      </div>

      <div className="cpw-body">
        <div className="cpw-field-label">
          <i className="bi bi-calendar-week" style={{ color: "#2563eb" }}></i> Allowed Backdated Days
        </div>
        <input
          className={`cpw-input${error ? " has-error" : ""}`}
          type="number" min={1} max={365}
          value={value}
          disabled={!editing}
          onChange={(e) => { setValue(e.target.value); setError(""); }}
        />
        <div style={{ fontSize: 12, color: "#64748b", marginTop: 6 }}>
          Employees can submit a daily report for today and up to {current ?? "-"} days back.
        </div>
        {error && <div className="cpw-error"><i className="bi bi-exclamation-circle-fill"></i>{error}</div>}
        {success && !error && (
          <div style={{ fontSize: 12, color: "#10b981", marginTop: 6 }}>
            <i className="bi bi-check-circle-fill"></i> {success}
          </div>
        )}
      </div>

      <div className="cpw-footer">
        {editing ? (
          <>
            <button className="cpw-btn-cancel" onClick={cancelEdit}>Cancel</button>
            <button className="cpw-btn-save" onClick={save} disabled={saving}>
              {saving ? "Saving…" : "Save"}
            </button>
          </>
        ) : (
          <>
            <button className="cpw-btn-cancel" onClick={onHide}>Close</button>
            <button className="cpw-btn-save" onClick={() => { setEditing(true); setSuccess(""); }}>Edit</button>
          </>
        )}
      </div>
    </Modal>
  );
};

export default BackdateConfigSetting;
